import { patch, read } from '@/utils/request'
import type { BatchProcessingParams, BatchProcessingRes, DetailWithLogs, ListData } from 'bv-typings'


export type IEntityPolicyListParams = {
  entityName?: string[]
  policyDate?: string
}

export type IEntityPolicyInfo = {
  id: string
  entityName: string
  entityId: string
  policyDate: string
  DRR: number
  LARR: number
  drr?: number
  larr?: number
}

export type IEntityPolicyListRes = ListData<IEntityPolicyInfo>

async function getEntityPolicyList (params?: IEntityPolicyListParams) {
  return read<IEntityPolicyListRes> ('policy_insight/entity_policy', params)
}

export type IEntityPolicyDetail = {
  list: Omit<IEntityPolicyInfo, 'entityId' | 'entityName'>[]
} & IEntityPolicyInfo

async function getEntityPolicyDetail (id: string) {
  return read<DetailWithLogs<IEntityPolicyDetail>> ('policy_insight/entity_policy', undefined, '获取开户主体Policy详情失败', id )
}

export type IEditEntityPolicyLarrParams = {
  larr: string
}

async function editEntityPolicyLarr (larr: string, id?: string) {
  return patch<any> ('policy_insight/single_entity_policy', { larr }, '修改Larr失败', id)
}

export type IEditEntityPolicyParams = Omit<IEntityPolicyInfo, 'entityId' | 'id' | 'drr'>
async function batchEditEntityPolicy (params: BatchProcessingParams<IEditEntityPolicyParams>[]) {
  return patch<BatchProcessingRes<IEditEntityPolicyParams>> ('policy_insight/entity_policy', params )
}

export {
  getEntityPolicyList,
  getEntityPolicyDetail,
  editEntityPolicyLarr,
  batchEditEntityPolicy,
}


